import React from "react";
import { Link } from "react-router-dom";

export default function About() {
    return (
        <div className="max-w-3xl mx-auto px-4 lg:px-6 py-14" data-testid="about-page">
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-ink">
                About BharatStack
            </h1>
            <p className="mt-5 text-lg text-ink-muted leading-relaxed">
                BharatStack is a curated, community-powered directory of
                Made-in-India digital products and services. We help Indian
                businesses, developers and creators discover credible local
                alternatives to global SaaS — across cloud, payments,
                communication, AI, productivity and 50+ more categories.
            </p>

            <h2 className="mt-10 font-heading font-bold text-2xl text-ink">
                Why we built it
            </h2>
            <p className="mt-3 text-base text-ink-muted leading-relaxed">
                The Indian SaaS ecosystem has matured incredibly in the last
                decade. Many of the world's most reliable email APIs, payment
                gateways, conferencing tools and AI platforms are built right
                here. BharatStack makes those choices visible — billing in ₹,
                hosted in India, supported in IST, compliant with DPDPA 2023.
            </p>

            <h2 className="mt-10 font-heading font-bold text-2xl text-ink">
                What you'll find
            </h2>
            <ul className="mt-3 space-y-2 text-base text-ink-muted">
                <li>• 202 strictly Indian products across 61 categories</li>
                <li>• 3 open opportunities — categories with no Indian alternative yet</li>
                <li>• "Why It's Indian" verification on every product</li>
                <li>• Free plans, open-source projects, INR billing flags</li>
                <li>• Direct links to official websites</li>
                <li>• Submit-a-product workflow for the community</li>
            </ul>

            <div className="mt-12 bg-gradient-to-r from-saffron via-saffron-600 to-indiagreen text-white rounded-2xl p-8 text-center">
                <h3 className="font-heading font-extrabold text-2xl">
                    Help grow India's tech directory
                </h3>
                <p className="mt-2 text-white/90">
                    Spotted a Made-in-India product we missed?
                </p>
                <Link
                    to="/submit"
                    className="mt-5 inline-flex items-center gap-2 bg-white text-saffron-700 hover:bg-cream font-semibold rounded-xl px-5 py-2.5"
                >
                    Submit it now →
                </Link>
            </div>
        </div>
    );
}
